import { useNavigate } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import './HeaderCalendarButton.css';

export default function HeaderCalendarButton() {
  const navigate = useNavigate();

  return (
    <div className="header-calendar-wrap">
      <button
        type="button"
        onClick={() => navigate('/calendar')}
        className="header-calendar-btn"
        title="Open Live Calendar"
      >
        <CalendarDays aria-hidden strokeWidth={2} />
      </button>
    </div>
  );
}
